import React from 'react';
import { render } from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://ddeb5bcad2208db31847ceef7ed744d3@o4509386316251136.ingest.us.sentry.io/4509386323394560',
  environment: import.meta.env.PROD ? 'medical-prod' : 'medical-dev',
  sampleRate: 1.0,
  tracesSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/admin\.ktaxpay\.com/,
    /^https:\/\/erp\.successmode\.co\.kr/,
  ],
  beforeSend(event) {
    // API 에러는 stack trace를 제거하여 Sentry에 전송
    // - 결국 API 에러는 axios Error handler 에서 호출되므로 Stack Trace가 필요하지 않다고 판단.
    // - name - message 기준으로 Sentry에서 에러를 병합시키고 구분할 수 있음.
    if (event.exception?.values) {
      event.exception.values = event.exception.values.map((ex) => {
        if (ex.type?.includes('Api')) {
          return {
            ...ex,
            stacktrace: undefined,
          };
        }
        return ex; // 일반 Exception(JS 에러)은 그대로 return
      });
    }
    return event;
  },
});
const rootElement = document.getElementById('root');

render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  rootElement,
);

reportWebVitals();
